<mat-tree [dataSource]="data" [treeControl]="dataTreeControl" cdkDropList (cdkDropListDropped)="drop($event)">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding cdkDrag [cdkDragData]="node"
        (mouseenter)="dragHover(node)" (mouseleave)="dragHoverEnd()" (cdkDragStarted)="dragStart()"
        (cdkDragReleased)="dragEnd()" [cdkDragDisabled]="!node.canMakeDragDrop"
        [ngClass]="{'selecthand': node.canMakeDragDrop }">
        <button mat-icon-button disabled></button>
        {{node.name}}
    </mat-tree-node>
    <mat-tree-node class="selecthand" *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding cdkDrag
        [cdkDragData]="node" (mouseenter)="dragHover(node)" (mouseleave)="dragHoverEnd()" (cdkDragStarted)="dragStart()"
        (cdkDragReleased)="dragEnd()" [cdkDragDisabled]="!node.canMakeDragDrop"
        [ngClass]="{'selecthand': node.canMakeDragDrop }">
        <button mat-icon-button matTreeNodeToggle (click)="expansionModel.toggle(node.id)"
            [attr.aria-label]="'toggle ' + node.name">
            <mat-icon class="mat-icon-rtl-mirror">
                {{dataTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
        </button>
        {{node.name}}
    </mat-tree-node>
</mat-tree>

<!-- Resultado: {{expansionModel.selected | json }} -->
